import { HqApiService } from 'hq/services/hqApiService';
import { OgpApiService } from 'ogp/services/ogp-api-service';
import { Site } from 'shared/hooks';
import { ProjectDetail, projectDetailSchema } from './project-service.schema';
import { ProjectDetailDto } from './project-service.dto';

export class ProjectService {
  constructor(
    private readonly ogpApiService: OgpApiService,
    private readonly hqApiService: HqApiService
  ) {}

  public getProjectDetail = async (site: Site, projectId: string): Promise<ProjectDetail> => {
    const response = await this.getProjectDetailImpl(site, projectId);
    return projectDetailSchema.parse(response);
  };

  private async getProjectDetailImpl(site: Site, projectId: string): Promise<ProjectDetailDto> {
    if (site === 'hq') {
      return await this.hqApiService.get<ProjectDetailDto>({
        path: `projects/${projectId}`,
      });
    }
    if (site === 'ogp') {
      return await this.ogpApiService.get<ProjectDetailDto>({
        path: `projects/${projectId}`,
      });
    }

    throw new Error('Not implemented');
  }
}
